// Small inline icons (stroke = currentColor) so they follow text color.
const base = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

export const IconSearch = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);
export const IconLocate = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    <circle cx="12" cy="12" r="8" />
  </svg>
);
export const IconCalendar = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M16 3v4M8 3v4M3 10h18" />
  </svg>
);
export const IconPin = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base}>
    <path d="M12 21s-7-6.2-7-11.5a7 7 0 1 1 14 0C19 14.8 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </svg>
);
export const IconLock = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base}>
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);
export const IconCheck = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base}>
    <path d="m5 12.5 4.5 4.5L19 7.5" />
  </svg>
);
export const IconBack = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base} width="20" height="20">
    <path d="M15 5l-7 7 7 7" />
  </svg>
);
export const IconRepeat = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base}>
    <path d="M17 2l3 3-3 3" />
    <path d="M4 11V9a4 4 0 0 1 4-4h12" />
    <path d="M7 22l-3-3 3-3" />
    <path d="M20 13v2a4 4 0 0 1-4 4H4" />
  </svg>
);
export const IconShop = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...base}>
    <path d="M4 9l1.5-5h13L20 9" />
    <path d="M4 9a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0" />
    <path d="M5 9v10h14V9" />
    <path d="M9 19v-6h6v6" />
  </svg>
);

export const IconFacebook = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor" width={18} height={18}>
    <path d="M13.5 21v-7.6h2.55l.38-2.96h-2.93V8.56c0-.86.24-1.44 1.47-1.44h1.57V4.49A21 21 0 0 0 14.3 4.4c-2.2 0-3.7 1.34-3.7 3.8v2.12H8.04v2.96H10.6V21z" />
  </svg>
);

/** Logo mark: brand rounded square with a white map pin. */
export const LogoMark = () => (
  <img
    className="brand-mark"
    src="/brand/topbar-mark.png"
    srcSet="/brand/topbar-mark.png 1x, /brand/topbar-mark@2x.png 2x"
    width={28}
    height={28}
    alt=""
    aria-hidden="true"
  />
);
